module.exports = __webpack_public_path__ + "static/media/boss.d4e060e5.png";